'use client';

import { c as _c } from "react/compiler-runtime";
import UserAbout from '@/app/[locale]/(worlds)/profile/components/UserAbout';
import UserFavorite from '@/app/[locale]/(worlds)/profile/components/UserFavorite';
import UserFeaturedRoomsHeader from '@/app/[locale]/(worlds)/profile/components/UserFeaturedRoomsHeader';
import UserFollowing from '@/app/[locale]/(worlds)/profile/components/UserFollowing';
import UserFollowingCreators from '@/app/[locale]/(worlds)/profile/components/UserFollowingCreators';
import UserMyPersonas from '@/app/[locale]/(worlds)/profile/components/UserMyPersonas';
import UserPhotoVideos from '@/app/[locale]/(worlds)/profile/components/UserPhotoVideos';
import UserUnlockedRooms from '@/app/[locale]/(worlds)/profile/components/UserUnlockedRooms';
import ProfileAnchors from '@/components/ProfileAnchors';
import SectionSeparator from '@/components/SectionSeparator';
export default function PrivateProfileContent() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-full flex-col gap-8 overflow-x-clip md:gap-9"><ProfileAnchors /><UserAbout /><SectionSeparator /><UserPhotoVideos /><SectionSeparator /><UserFeaturedRoomsHeader /><UserMyPersonas /><SectionSeparator /><UserFavorite /><SectionSeparator /><UserFollowingCreators /><SectionSeparator /><UserFollowing /><SectionSeparator /><UserUnlockedRooms /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}